import { PocTypography } from 'commons/components/components-wrapper';
import { useTranslation } from 'core/i18n/i18n';
import React, { ReactNode } from 'react';
import {
    LayoutQuickDetailSectionComponent,
    LayoutQuickDetailSectionContentComponent,
    LayoutQuickDetailSectionHeaderComponent,
} from './quick-detail-section.style';

export interface QuickDetailSectionComponentProps extends React.PropsWithChildren {
    headerTitle: string;
    headerValue?: number;
    suffix?: ReactNode;
}

export const QuickDetailSectionComponent: React.FC<QuickDetailSectionComponentProps> = (props) => {
    const { headerTitle, headerValue, suffix, children } = props;
    const { t } = useTranslation();

    return (
        <LayoutQuickDetailSectionComponent>
            <LayoutQuickDetailSectionHeaderComponent>
                <PocTypography element="span" variant="subtitle1" style={{ paddingRight: '8px' }}>
                    {t(headerTitle, { value: headerValue })}
                </PocTypography>

                {suffix ?? null}
            </LayoutQuickDetailSectionHeaderComponent>
            <LayoutQuickDetailSectionContentComponent>{children}</LayoutQuickDetailSectionContentComponent>
        </LayoutQuickDetailSectionComponent>
    );
};
